export default function TripCheckoutEuRailsController() {
    'ngInject';
    const vm = this;


    // !!!!! this is not needed !!!
    Object.assign(vm, {
        railSeatCount: 12,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/trip-checkout-eurails-controller.js